import { AfterContentInit, Component, OnInit } from '@angular/core';
import { IBDProcess } from 'src/app/domain/IBD/IDB-process';
import { IntensiteColmatage } from 'src/app/domain/IBD/enum/intensite-colmatage';
import { Ombre } from 'src/app/domain/IBD/enum/ombre';
import { SupportIBD } from 'src/app/domain/IBD/enum/support-IBD';
import { TypeOutilPrelevement } from 'src/app/domain/IBD/enum/type-outil-prelevement';
import { ClasseVitesse } from 'src/app/domain/Shared/classe-vitesse';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { ActivatedRoute, Router } from '@angular/router';
import { PrelevementIBD } from 'src/app/domain/IBD/prelevement-ibd';
import { IBDService } from 'src/app/services/ibd.service';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { CoreData } from 'src/app/tools/core-data';
import { IbdMeasureBoxComponent } from 'src/app/tools/ui/ibd-measure-box/ibd-measure-box.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelectChange } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';
import { SimpleListModel } from 'src/app/models/simple-list-model';

@Component({
    selector: 'app-ibd',
    templateUrl: './ibd.component.html',
    styleUrls: ['./ibd.component.scss']
})
export class IBDComponent implements OnInit, AfterContentInit {
    private MESURE_MAX = 10;
    private MAX_PERCENTAGE = 100;
    IsY2FarControl = new UntypedFormControl('', Validators.compose([
        Validators.pattern(/^(\d{7})?$/)]));
    IsX2FarControl = new UntypedFormControl('', Validators.compose([
        Validators.pattern(/^(\d{6})?$/)]));
    TotalPercentageControl = new UntypedFormControl('', Validators.compose([
        this.checkTotal(),
        Validators.max(this.MAX_PERCENTAGE)]));
    AlguePercentageControl = new UntypedFormControl('', this.checkAlgues());
    BryoPercentageControl = new UntypedFormControl('', this.checkBryo());

    public ClasseVitesseList: string[] = Object.values(ClasseVitesse)
        .filter(x => !isNaN(Number(x)) && x !== 6)
        .map(x => StringConverter.getClasseVitesseName(x as ClasseVitesse));
    public OutilPrelevementList: string[] = Object.values(TypeOutilPrelevement)
        .filter(x => !isNaN(Number(x)))
        .map(x => StringConverter.getOutilPrelevementName(x as TypeOutilPrelevement));
    public OmbreList: string[] = Object.values(Ombre).filter(x => !isNaN(Number(x))).map(x => StringConverter.getOmbreName(x as Ombre));
    public SupportList: SimpleListModel[] = Object.values(SupportIBD)
        .filter(x => !isNaN(Number(x)))
        .map(x => {
            const n = new SimpleListModel();
            n.s = StringConverter.getSupportIBDName(x as SupportIBD);
            n.idx = x as number;
            return n;
        })

    public IntensiteColmatageList: string[] = Object.values(IntensiteColmatage)
        .filter(x => !isNaN(Number(x)))
        .map(x => StringConverter.getIntensiteColmatageName(x as IntensiteColmatage));
    public model: IBDProcess = new IBDProcess();

    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        private coreData: CoreData,
        public dialog: MatDialog,
        private ibdservice: IBDService,
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.save(true);
            }
        })
    }

    ngOnInit() {
    }

    ngAfterContentInit(): void {
        if (!this.route.snapshot.params.processCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        if (this.coreData.IsOffline) {
            this.model = Object.assign(new IBDProcess(), this.coreData.getOfflineProcess(this.route.snapshot.params.processCode));
            this.model.Code = this.route.snapshot.params.processCode;
        } else {
            this.ibdservice.getProcessByCode(this.route.snapshot.params.processCode).subscribe(x => {
                this.model = x;
                this.model.Code = this.route.snapshot.params.processCode;
            });
        }
        this.TotalPercentageControl.markAsTouched();
        this.BryoPercentageControl.markAsTouched();
        this.AlguePercentageControl.markAsTouched();
        this.IsX2FarControl.markAsTouched();
        this.IsY2FarControl.markAsTouched();
    }

    canSave() {
        if (!this.TotalPercentageControl.valid || !this.BryoPercentageControl.valid || !this.AlguePercentageControl.valid) {
            return false;
        }
        return true;
    }

    onTotalKeyUpEvent($event) {
        this.BryoPercentageControl.updateValueAndValidity();
        this.AlguePercentageControl.updateValueAndValidity();
    }
    onBryoKeyUpEvent($event) {
        this.TotalPercentageControl.updateValueAndValidity();
        this.AlguePercentageControl.updateValueAndValidity();
    }
    onAlgueKeyUpEvent($event) {
        this.TotalPercentageControl.updateValueAndValidity();
        this.BryoPercentageControl.updateValueAndValidity();
    }

    checkTotal(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            // Do not test initialisation value
            control.value === '' ||
                this.BryoPercentageControl.value === undefined ||
                this.AlguePercentageControl.value === undefined ||
                (this.model && this.model.RecouvrementVegetal &&
                    control.value >= this.BryoPercentageControl.value &&
                    control.value >= this.AlguePercentageControl.value)
                //  && control.value >= this.BryoPercentageControl.value + this.AlguePercentageControl.value)
                ? null : { wrongColor: control.value };
    }

    checkBryo(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            // Do not test initialisation value
            control.value === '' ||
                this.TotalPercentageControl.value === undefined ||
                this.AlguePercentageControl.value === undefined ||
                (this.model && this.model.RecouvrementVegetal &&
                    this.TotalPercentageControl.value >= this.BryoPercentageControl.value &&
                    this.TotalPercentageControl.value >= this.AlguePercentageControl.value)
                // this.TotalPercentageControl.value >= control.value + this.AlguePercentageControl.value

                ? null : { wrongColor: control.value };
    }

    checkAlgues(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.model && this.model.RecouvrementVegetal &&
                this.TotalPercentageControl.value >= this.BryoPercentageControl.value &&
                this.TotalPercentageControl.value >= this.AlguePercentageControl.value
                // this.TotalPercentageControl.value >= this.BryoPercentageControl.value + control.value
                ? null : { wrongColor: control.value };
    }

    selectedSupportType(event: MatSelectChange) {
        this.model.Outil = null;
        if (event.value === SupportIBD.PierreGalet) {
            this.model.Outil = TypeOutilPrelevement.Brosse;
        }
    }

    getVitesseIndex(c: string) {
        // return Object.values(ClasseVitesse).filter(x => !isNaN(Number(x)) && c.charAt(1) === x).map(y => y)[0];
        return Object.values(ClasseVitesse).filter(x => !isNaN(Number(x)) && x === Number(c.charAt(1))).map(y => y)[0];
    }

    openIBDMesureBox(idbMesure?: PrelevementIBD) {
        if (this.model.Prelevements.length >= this.MESURE_MAX) {
            NotificationManager.handleWarning(`Le nombre maximal de mesure est de ${this.MESURE_MAX}`, this.snackBar);
            return;
        }

        const dialogRef = this.dialog.open(IbdMeasureBoxComponent, {
            data: Object.assign({}, idbMesure) ?? new PrelevementIBD(),
            width: '333px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: PrelevementIBD) => {
            if (result) {
                if (!idbMesure) {
                    this.model.Prelevements.push(result);
                } else {
                    Object.assign(idbMesure, result);
                }
            }
        });
    }

    removeMeasure(measure: PrelevementIBD) {
        _.remove(this.model.Prelevements, x => x === measure);
    }

    save(forced: boolean) {
        if (!this.canSave() && !forced) {
            return;
        }
        if (this.coreData.IsOffline) {
            this.coreData.setOfflineProcess(this.model);
        } else {
            this.ibdservice.updateProcess(this.model).subscribe(x => {
                NotificationManager.handleSuccess('Intervention enregistrée', this.snackBar);
            });
        }
    }
}
